import {
    ButtonFixedFooterLayout,
    ButtonPrimary,
    Circle,
    IconDeviceSignalRegular,
    IconRouterRegular,
    NavigationBar,
    Row,
    Text6,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const ModalCheckSpeed: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const size = useWindowSize();
    const storage = localStorage.getItem('storage');
    let fiber: any;
    let productId: any;
    if (storage) {
        const storageJson = JSON.parse(storage);
        fiber = storageJson;
        productId = fiber.productId;
    }

    const sendToNative = (url: string) => {
        const type = 'fiber-test-speed';
        const title = 'Test de velocidad';
        const queryParams = { productId: productId };
        if (navigateParams(type, url, queryParams, fiber, title)) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='modalCheckSpeed-page'>
            {!(isWebviewAndroid || isWebviewIOS) && size.width < 1024 && (
                <div className='modalCheckSpeed-page__header-navigationBar'>
                    <NavigationBar
                        isInverse={true}
                        onBack={() => {
                            navigate(-1);
                        }}
                        title={t('speedTestFiber')}
                    />
                </div>
            )}
            {size.width >= 1024 ? (
                <>
                    <div className='modalCheckSpeed-page__title'>
                        <Text6>{t('measureConnection')}</Text6>
                    </div>
                    <div className='modalCheckSpeed-page__content'>
                        <Row
                            asset={
                                <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                    <IconDeviceSignalRegular color={skinVars.colors.brand} />
                                </Circle>
                            }
                            title={t('mobileDataConnectionTitle')}
                            description={t('mobileDataConnectionDescription')}
                        ></Row>
                        <Row
                            asset={
                                <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                    <IconRouterRegular color={skinVars.colors.brand} />
                                </Circle>
                            }
                            title={t('wifiNetworkConnectionTitle')}
                            description={t('wifiNetworkConnectionDescription')}
                        ></Row>
                        <div className='modalCheckSpeed-page__button'>
                            <ButtonPrimary onPress={() => sendToNative('/fiber/fiber-test-velocity')}>
                                {t('btnCheckSpeed')}
                            </ButtonPrimary>
                        </div>
                    </div>
                </>
            ) : (
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary onPress={() => sendToNative('/fiber/fiber-test-velocity')}>
                            {t('btnCheckSpeed')}
                        </ButtonPrimary>
                    }
                >
                    <div className='modalCheckSpeed-page__title'>
                        <Text6>{t('measureConnection')}</Text6>
                    </div>
                    <div className='modalCheckSpeed-page__content'>
                        <Row
                            asset={
                                <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                    <IconDeviceSignalRegular color={skinVars.colors.brand} />
                                </Circle>
                            }
                            title={t('mobileDataConnectionTitle')}
                            description={t('mobileDataConnectionDescription')}
                        ></Row>
                        <Row
                            asset={
                                <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                    <IconRouterRegular color={skinVars.colors.brand} />
                                </Circle>
                            }
                            title={t('wifiNetworkConnectionTitle')}
                            description={t('wifiNetworkConnectionDescription')}
                        ></Row>
                    </div>
                </ButtonFixedFooterLayout>
            )}
        </div>
    );
};

export default ModalCheckSpeed;
